import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Clients.css';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimpleText from 'components/shared/text/SimpleText';
import Number from 'components/shared/text/Number';
import {
  clearClientForm,
  goToClient,
  loadClientsRequest,
  setShowInviteClientModal,
} from 'actions/admin/clients/clients';
import {
  getClients,
  getClientsCurrentPage,
  getClientsTotal,
  getClientsPageSize,
} from 'selectors/admin/clients/clients';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import Button from 'components/shared/button/Button';
import ClientInviteModal from './ClientInviteModal';
import { getCurrentUser } from 'selectors/authentication';
import SimplePagination from 'components/shared/pagination/SimplePagination';

class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = { nameToSearch: '' };
  }

  componentDidMount() {
    this.props.dispatch(loadClientsRequest(1));
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleClientSelection = (index) => {
    simpleScrollToTop();
    this.props.dispatch(goToClient(this.props.clients[index].id));
  };

  handleClientsPageChange = (newPage) => {
    this.props.dispatch(loadClientsRequest(newPage));
  };

  handleSearchTextChange = (value) => {
    this.setState({ nameToSearch: value });
    this.props.dispatch(loadClientsRequest(1, value));
  };

  handleSearchTextClear = () => {
    this.handleSearchTextChange('');
  };

  handleGenerateLink = (index) => {
    const { clients } = this.props;
    return `clients/${clients[index].id}`;
  };

  render() {
    const { nameToSearch } = this.state;
    return (
      <div className="clients">
        <div className="full-title">Clients</div>

        <div className="content-container">
          <SearchBar
            addButton={
              <Button
                id="invite-client"
                className="button-orange"
                label="Invite Client"
                onClick={this.handleInviteClient}
              />
            }
            searchPlaceHolder="Search by Name"
            searchText={nameToSearch}
            onSearchTextChange={this.handleSearchTextChange}
            onClearText={this.handleSearchTextClear}
            onSearch={this.handleSearchTextChange}
          >
            &nbsp;
          </SearchBar>

          <SimpleTable
            className="clients-table"
            headers={[
              'COMPANY NAME',
              'ADDRESS',
              'POC',
              'IN PROGRESS',
              'COMPLETED',
              'BALANCE DUE',
            ]}
            rows={this.mapClients(this.props.clients)}
            emptyMessage="No Clients"
            onRowSelected={this.handleClientSelection}
            onGenerateLink={this.handleGenerateLink}
          />

          <div className="pagination-container">
            <SimplePagination
              currentPage={this.props.clientsCurrentPage}
              pageSize={this.props.clientsPageSize}
              total={this.props.clientsTotal}
              onPageChange={this.handleClientsPageChange}
            />
          </div>
        </div>

        <ClientInviteModal />
      </div>
    );
  }

  handleInviteClient = () => {
    this.props.dispatch(clearClientForm());
    this.props.dispatch(setShowInviteClientModal(true));
  };

  mapClients = (clients) => {
    return clients.map((client) => {
      return [
        <span className="h4">{client.company_name}</span>,
        <SimpleText
          lines={
            client.location !== null
              ? [client.location.street_address_1, client.location.city]
              : ['N/A']
          }
        />,
        client.contact !== null
          ? client.contact.first_name + ' ' + client.contact.last_name
          : 'N/A',
        client.wo_in_progress_count,
        client.wo_complete_count,
        client.balance_due !== null ? (
          <Number value={client.balance_due} format="$0,0" />
        ) : (
          'N/A'
        ),
      ];
    });
  };
}

export default connect((state) => {
  return {
    clients: getClients(state),
    currentUser: getCurrentUser(state),
    clientsCurrentPage: getClientsCurrentPage(state),
    clientsTotal: getClientsTotal(state),
    clientsPageSize: getClientsPageSize(state),
  };
})(Clients);



// WEBPACK FOOTER //
// ./src/components/admin/clients/Clients.js